var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-layout"},[_c('v-main',[_c('v-container',{staticClass:"h-full",attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.path})],1),_c('Notification'),_c('NotificationDialog')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }